// src/components/ui/alert.js
import React from 'react';
import { useConfig } from '../../context/ConfigContext';

export const Alert = ({ children, variant = 'default', className = '' }) => {
  const { config } = useConfig();
  const bgColor = variant === 'destructive' 
    ? 'bg-red-50 border-red-200' 
    : `border ${className}`; // Remove default bg-gray-50 class to use style
  
  return (
    <div 
      className={`p-4 rounded-lg ${bgColor}`}
      style={{ 
        backgroundColor: variant === 'destructive' ? '#FEF2F2' : `${config.colors.backgroundAlt}`,
        borderColor: variant === 'destructive' ? '#FECACA' : `${config.colors.textSecondary}20`
      }}
    >
      {children}
    </div>
  );
};

export const AlertDescription = ({ children }) => {
  const { config } = useConfig();
  
  return (
    <div 
      className="text-sm ml-2 inline-block"
      style={{ color: config.colors.textSecondary }}
    >
      {children}
    </div>
  );
};



// // src/components/ui/alert.js
// import React from 'react';

// export const Alert = ({ children, variant = 'default', className = '' }) => {
//   const bgColor = variant === 'destructive' ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-200';
//   return (
//     <div className={`p-4 border rounded-lg ${bgColor} ${className}`}>
//       {children}
//     </div>
//   );
// };

// export const AlertDescription = ({ children }) => (
//   <div className="text-sm text-gray-700 ml-2 inline-block">
//     {children}
//   </div>
// );